"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Particle = void 0;

var ParticlesOptions_1 = require("../Options/Classes/Particles/ParticlesOptions");

var Shape_1 = require("../Options/Classes/Particles/Shape/Shape");

var Enums_1 = require("../Enums");

var Utils_1 = require("../Utils");

var Vector_1 = require("./Particle/Vector");

var Vector3d_1 = require("./Particle/Vector3d");

var Particle = /*#__PURE__*/function () {
  function Particle(id, container, position, overrideOptions, group) {
    _classCallCheck(this, Particle);

    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;

    this.id = id;
    this.container = container;
    this.group = group;
    this.fill = true;
    this.close = true;
    this.lastPathTime = 0;
    this.destroyed = false;
    this.unbreakable = false;
    this.splitCount = 0;
    this.misplaced = false;
    this.loops = {
      opacity: 0,
      size: 0
    };
    this.maxDistance = {};
    var pxRatio = container.retina.pixelRatio;
    var options = container.actualOptions;
    var particlesOptions = new ParticlesOptions_1.ParticlesOptions();
    particlesOptions.load(options.particles);
    var shapeType = particlesOptions.shape.type;
    var reduceDuplicates = particlesOptions.reduceDuplicates;
    this.shape = shapeType instanceof Array ? Utils_1.itemFromArray(shapeType, this.id, reduceDuplicates) : shapeType;

    if (overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions.shape) {
      if (overrideOptions.shape.type) {
        var overrideShapeType = overrideOptions.shape.type;
        this.shape = overrideShapeType instanceof Array ? Utils_1.itemFromArray(overrideShapeType, this.id, reduceDuplicates) : overrideShapeType;
      }

      var shapeOptions = new Shape_1.Shape();
      shapeOptions.load(overrideOptions.shape);

      if (this.shape) {
        this.shapeData = this.loadShapeData(shapeOptions, reduceDuplicates);
      }
    } else {
      this.shapeData = this.loadShapeData(particlesOptions.shape, reduceDuplicates);
    }

    if (overrideOptions !== undefined) {
      particlesOptions.load(overrideOptions);
    }

    if (((_a = this.shapeData) === null || _a === void 0 ? void 0 : _a.particles) !== undefined) {
      particlesOptions.load((_b = this.shapeData) === null || _b === void 0 ? void 0 : _b.particles);
    }

    this.fill = (_d = (_c = this.shapeData) === null || _c === void 0 ? void 0 : _c.fill) !== null && _d !== void 0 ? _d : this.fill;
    this.close = (_f = (_e = this.shapeData) === null || _e === void 0 ? void 0 : _e.close) !== null && _f !== void 0 ? _f : this.close;
    this.options = particlesOptions;
    var zIndexValue = Utils_1.getRangeValue(this.options.zIndex.value);
    this.pathDelay = Utils_1.getValue(this.options.move.path.delay) * 1000;
    this.wobbleDistance = 0;
    container.retina.initParticle(this);
    var color = this.options.color;
    var sizeOptions = this.options.size;
    var sizeValue = Utils_1.getValue(sizeOptions) * container.retina.pixelRatio;
    this.size = {
      value: sizeValue,
      max: Utils_1.getRangeMax(sizeOptions.value) * pxRatio,
      min: Utils_1.getRangeMin(sizeOptions.value) * pxRatio
    };
    var sizeAnimation = sizeOptions.animation;

    if (sizeAnimation.enable) {
      this.size.status = Enums_1.AnimationStatus.increasing;
      var sizeRange = Utils_1.setRangeValue(sizeOptions.value, sizeAnimation.minimumValue * pxRatio);
      this.size.min = Utils_1.getRangeMin(sizeRange);
      this.size.max = Utils_1.getRangeMax(sizeRange);

      switch (sizeAnimation.startValue) {
        case Enums_1.StartValueType.min:
          this.size.value = this.size.min;
          this.size.status = Enums_1.AnimationStatus.increasing;
          break;

        case Enums_1.StartValueType.random:
          this.size.value = Utils_1.randomInRange(this.size);
          this.size.status = Math.random() >= 0.5 ? Enums_1.AnimationStatus.increasing : Enums_1.AnimationStatus.decreasing;
          break;

        case Enums_1.StartValueType.max:
        default:
          this.size.value = this.size.max;
          this.size.status = Enums_1.AnimationStatus.decreasing;
          break;
      }

      this.size.velocity = ((_g = this.sizeAnimationSpeed) !== null && _g !== void 0 ? _g : container.retina.sizeAnimationSpeed) / 100 * container.retina.reduceFactor;

      if (!sizeAnimation.sync) {
        this.size.velocity *= Math.random();
      }
    }

    this.direction = Utils_1.getParticleDirectionAngle(this.options.move.direction);
    this.bubble = {
      inRange: false
    };
    this.initialVelocity = this.calculateVelocity();
    this.velocity = this.initialVelocity.copy();
    var rotateOptions = this.options.rotate;
    this.rotate = {
      value: Utils_1.getRangeValue(rotateOptions.value) * Math.PI / 180
    };
    var rotateDirection = rotateOptions.direction;

    if (rotateDirection === Enums_1.RotateDirection.random) {
      var index = Math.floor(Math.random() * 2);
      rotateDirection = index > 0 ? Enums_1.RotateDirection.counterClockwise : Enums_1.RotateDirection.clockwise;
    }

    switch (rotateDirection) {
      case Enums_1.RotateDirection.counterClockwise:
      case "counterClockwise":
        this.rotate.status = Enums_1.AnimationStatus.decreasing;
        break;

      case Enums_1.RotateDirection.clockwise:
        this.rotate.status = Enums_1.AnimationStatus.increasing;
        break;
    }

    var rotateAnimation = this.options.rotate.animation;

    if (rotateAnimation.enable) {
      this.rotate.velocity = rotateAnimation.speed / 360 * container.retina.reduceFactor;

      if (!rotateAnimation.sync) {
        this.rotate.velocity *= Math.random();
      }
    }

    var tiltOptions = this.options.tilt;
    this.tilt = {
      value: Utils_1.getRangeValue(tiltOptions.value) * Math.PI / 180,
      sinDirection: Math.random() >= 0.5 ? 1 : -1,
      cosDirection: Math.random() >= 0.5 ? 1 : -1
    };
    var tiltDirection = tiltOptions.direction;

    if (tiltDirection === Enums_1.TiltDirection.random) {
      var _index = Math.floor(Math.random() * 2);

      tiltDirection = _index > 0 ? Enums_1.TiltDirection.counterClockwise : Enums_1.TiltDirection.clockwise;
    }

    switch (tiltDirection) {
      case Enums_1.TiltDirection.counterClockwise:
      case "counterClockwise":
        this.tilt.status = Enums_1.AnimationStatus.decreasing;
        break;

      case Enums_1.TiltDirection.clockwise:
        this.tilt.status = Enums_1.AnimationStatus.increasing;
        break;
    }

    var tiltAnimation = this.options.tilt.animation;

    if (tiltAnimation.enable) {
      this.tilt.velocity = tiltAnimation.speed / 360 * container.retina.reduceFactor;

      if (!tiltAnimation.sync) {
        this.tilt.velocity *= Math.random();
      }
    }

    var orbitOptions = particlesOptions.orbit;

    if (orbitOptions.enable) {
      this.orbitRotation = Utils_1.getRangeValue(orbitOptions.rotation.value);
      this.orbitColor = Utils_1.colorToHsl(orbitOptions.color);
    }

    var hslColor = Utils_1.colorToHsl(color, this.id, reduceDuplicates);

    if (hslColor) {
      this.color = {
        h: {
          value: hslColor.h
        },
        s: {
          value: hslColor.s
        },
        l: {
          value: hslColor.l
        }
      };
      var colorAnimation = this.options.color.animation;
      this.setColorAnimation(colorAnimation.h, this.color.h);
      this.setColorAnimation(colorAnimation.s, this.color.s);
      this.setColorAnimation(colorAnimation.l, this.color.l);
    }

    var rollOpt = this.options.roll;

    if (rollOpt.enable) {
      if (this.color) {
        if (rollOpt.backColor) {
          this.backColor = Utils_1.colorToHsl(rollOpt.backColor);
        } else if (rollOpt.darken.enable && rollOpt.enlighten.enable) {
          this.alterType = Math.random() >= 0.5 ? Enums_1.AlterType.darken : Enums_1.AlterType.enlighten;
          this.alterValue = this.alterType === Enums_1.AlterType.darken ? rollOpt.darken.value : rollOpt.enlighten.value;
        } else if (rollOpt.darken.enable) {
          this.alterType = Enums_1.AlterType.darken;
          this.alterValue = rollOpt.darken.value;
        } else if (rollOpt.enlighten.enable) {
          this.alterType = Enums_1.AlterType.enlighten;
          this.alterValue = rollOpt.enlighten.value;
        }
      }

      this.rollAngle = Math.random() * Math.PI * 2;
      this.rollSpeed = Utils_1.getRangeValue(rollOpt.speed) / 360;
    } else {
      this.rollAngle = 0;
      this.rollSpeed = 0;
    }

    var wobbleOpt = this.options.wobble;

    if (wobbleOpt.enable) {
      this.wobbleAngle = Math.random() * Math.PI * 2;
      this.wobbleSpeed = Utils_1.getRangeValue(wobbleOpt.speed) / 360;
    } else {
      this.wobbleAngle = 0;
      this.wobbleSpeed = 0;
    }

    this.position = this.calcPosition(container, position, Utils_1.clamp(zIndexValue, 0, container.zLayers));
    this.initialPosition = this.position.copy();
    this.offset = Vector_1.Vector.origin;
    var particles = container.particles;
    particles.needsSort = particles.needsSort || particles.lastZIndex < this.position.z;
    particles.lastZIndex = this.position.z;
    this.zIndexFactor = this.position.z / container.zLayers;
    var opacityOptions = this.options.opacity;
    this.opacity = {
      max: Utils_1.getRangeMax(opacityOptions.value),
      min: Utils_1.getRangeMin(opacityOptions.value),
      value: Utils_1.getValue(opacityOptions)
    };
    var opacityAnimation = opacityOptions.animation;

    if (opacityAnimation.enable) {
      this.opacity.status = Enums_1.AnimationStatus.increasing;
      var opacityRange = Utils_1.setRangeValue(opacityOptions.value, opacityAnimation.minimumValue);
      this.opacity.min = Utils_1.getRangeMin(opacityRange);
      this.opacity.max = Utils_1.getRangeMax(opacityRange);

      switch (opacityAnimation.startValue) {
        case Enums_1.StartValueType.min:
          this.opacity.value = this.opacity.min;
          this.opacity.status = Enums_1.AnimationStatus.increasing;
          break;

        case Enums_1.StartValueType.random:
          this.opacity.value = Utils_1.randomInRange(this.opacity);
          this.opacity.status = Math.random() >= 0.5 ? Enums_1.AnimationStatus.increasing : Enums_1.AnimationStatus.decreasing;
          break;

        case Enums_1.StartValueType.max:
        default:
          this.opacity.value = this.opacity.max;
          this.opacity.status = Enums_1.AnimationStatus.decreasing;
          break;
      }

      this.opacity.velocity = opacityAnimation.speed / 100 * container.retina.reduceFactor;

      if (!opacityAnimation.sync) {
        this.opacity.velocity *= Math.random();
      }
    }

    this.sides = 24;
    var drawer = container.drawers.get(this.shape);

    if (!drawer) {
      drawer = Utils_1.Plugins.getShapeDrawer(this.shape);

      if (drawer) {
        container.drawers.set(this.shape, drawer);
      }
    }

    if (drawer === null || drawer === void 0 ? void 0 : drawer.loadShape) {
      drawer === null || drawer === void 0 ? void 0 : drawer.loadShape(this);
    }

    var sideCountFunc = drawer === null || drawer === void 0 ? void 0 : drawer.getSidesCount;

    if (sideCountFunc) {
      this.sides = sideCountFunc(this);
    }

    this.stroke = this.options.stroke instanceof Array ? Utils_1.itemFromArray(this.options.stroke, this.id, reduceDuplicates) : this.options.stroke;
    this.strokeWidth = this.stroke.width * container.retina.pixelRatio;
    var strokeHslColor = (_h = Utils_1.colorToHsl(this.stroke.color)) !== null && _h !== void 0 ? _h : this.getFillColor();

    if (strokeHslColor) {
      this.strokeColor = {
        h: {
          value: strokeHslColor.h
        },
        s: {
          value: strokeHslColor.s
        },
        l: {
          value: strokeHslColor.l
        }
      };
      var strokeColorAnimation = (_j = this.stroke.color) === null || _j === void 0 ? void 0 : _j.animation;

      if (strokeColorAnimation && this.strokeColor) {
        this.setColorAnimation(strokeColorAnimation.h, this.strokeColor.h);
        this.setColorAnimation(strokeColorAnimation.s, this.strokeColor.s);
        this.setColorAnimation(strokeColorAnimation.l, this.strokeColor.l);
      }
    }

    this.life = this.loadLife();
    this.spawning = this.life.delay > 0;

    if (this.options.move.spin.enable) {
      var spinPos = (_k = this.options.move.spin.position) !== null && _k !== void 0 ? _k : {
        x: 50,
        y: 50
      };
      var spinCenter = {
        x: spinPos.x / 100 * container.canvas.size.width,
        y: spinPos.y / 100 * container.canvas.size.height
      };
      var pos = this.getPosition();
      var distance = Utils_1.getDistance(pos, spinCenter);
      this.spin = {
        center: spinCenter,
        direction: this.velocity.x >= 0 ? Enums_1.RotateDirection.clockwise : Enums_1.RotateDirection.counterClockwise,
        angle: this.velocity.angle,
        radius: distance,
        acceleration: Utils_1.getRangeValue(this.options.move.spin.acceleration)
      };
    }

    this.shadowColor = Utils_1.colorToRgb(this.options.shadow.color);

    if (drawer && drawer.particleInit) {
      drawer.particleInit(container, this);
    }

    var _iterator = _createForOfIteratorHelper(container.plugins),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            plugin = _step$value[1];

        if (plugin.particleCreated) {
          plugin.particleCreated(this);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  _createClass(Particle, [{
    key: "isVisible",
    value: function isVisible() {
      return !this.destroyed && !this.spawning && this.isInsideCanvas();
    }
  }, {
    key: "isInsideCanvas",
    value: function isInsideCanvas() {
      var radius = this.getRadius();
      var canvasSize = this.container.canvas.size;
      return this.position.x >= -radius && this.position.y >= -radius && this.position.y <= canvasSize.height + radius && this.position.x <= canvasSize.width + radius;
    }
  }, {
    key: "draw",
    value: function draw(delta) {
      var container = this.container;

      var _iterator2 = _createForOfIteratorHelper(container.plugins),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              plugin = _step2$value[1];

          container.canvas.drawParticlePlugin(plugin, this, delta);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      container.canvas.drawParticle(this, delta);
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        x: this.position.x + this.offset.x,
        y: this.position.y + this.offset.y,
        z: this.position.z
      };
    }
  }, {
    key: "getRadius",
    value: function getRadius() {
      return this.bubble.radius || this.size.value;
    }
  }, {
    key: "getMass",
    value: function getMass() {
      var radius = this.getRadius();
      return Math.pow(radius, 2) * Math.PI / 2;
    }
  }, {
    key: "getFillColor",
    value: function getFillColor() {
      if (this.bubble.color) {
        return this.bubble.color;
      }

      var color = Utils_1.getHslFromAnimation(this.color);

      if (color && (this.backColor || this.alterType && this.alterValue !== undefined)) {
        var rolled = Math.floor(this.rollAngle / (Math.PI / 2)) % 2;

        if (rolled) {
          if (this.backColor) {
            return this.backColor;
          } else if (this.alterType && this.alterValue !== undefined) {
            return {
              h: color.h,
              s: color.s,
              l: color.l + (this.alterType === Enums_1.AlterType.darken ? -1 : 1) * this.alterValue
            };
          }
        }
      }

      return color;
    }
  }, {
    key: "getStrokeColor",
    value: function getStrokeColor() {
      var _a, _b;

      return (_b = (_a = this.bubble.color) !== null && _a !== void 0 ? _a : Utils_1.getHslFromAnimation(this.strokeColor)) !== null && _b !== void 0 ? _b : this.getFillColor();
    }
  }, {
    key: "destroy",
    value: function destroy(override) {
      this.destroyed = true;
      this.bubble.inRange = false;

      if (this.unbreakable) {
        return;
      }

      this.destroyed = true;
      this.bubble.inRange = false;

      var _iterator3 = _createForOfIteratorHelper(this.container.plugins),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              plugin = _step3$value[1];

          if (plugin.particleDestroyed) {
            plugin.particleDestroyed(this, override);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (override) {
        return;
      }

      var destroyOptions = this.options.destroy;

      if (destroyOptions.mode === Enums_1.DestroyMode.split) {
        this.split();
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.loops.opacity = 0;
      this.loops.size = 0;
    }
  }, {
    key: "split",
    value: function split() {
      var splitOptions = this.options.destroy.split;

      if (splitOptions.count >= 0 && this.splitCount++ > splitOptions.count) {
        return;
      }

      var rate = Utils_1.getRangeValue(splitOptions.rate.value);

      for (var i = 0; i < rate; i++) {
        this.container.particles.addSplitParticle(this);
      }
    }
  }, {
    key: "setColorAnimation",
    value: function setColorAnimation(colorAnimation, colorValue) {
      if (colorAnimation.enable) {
        colorValue.velocity = colorAnimation.speed / 100 * this.container.retina.reduceFactor;

        if (colorAnimation.sync) {
          return;
        }

        colorValue.status = Enums_1.AnimationStatus.increasing;
        colorValue.velocity *= Math.random();

        if (colorValue.value) {
          colorValue.value *= Math.random();
        }
      } else {
        colorValue.velocity = 0;
      }
    }
  }, {
    key: "calcPosition",
    value: function calcPosition(container, position, zIndex) {
      var tryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      var _a, _b;

      var _iterator4 = _createForOfIteratorHelper(container.plugins),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              plugin = _step4$value[1];

          var pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, this) : undefined;

          if (pluginPos !== undefined) {
            return Vector3d_1.Vector3d.create(pluginPos.x, pluginPos.y, zIndex);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var canvasSize = container.canvas.size;
      var pos = Vector3d_1.Vector3d.create((_a = position === null || position === void 0 ? void 0 : position.x) !== null && _a !== void 0 ? _a : Math.random() * canvasSize.width, (_b = position === null || position === void 0 ? void 0 : position.y) !== null && _b !== void 0 ? _b : Math.random() * canvasSize.height, zIndex);
      var outMode = this.options.move.outMode;

      if (Utils_1.isInArray(outMode, Enums_1.OutMode.bounce) || Utils_1.isInArray(outMode, Enums_1.OutMode.bounceHorizontal)) {
        if (pos.x > container.canvas.size.width - this.size.value * 2) {
          pos.x -= this.size.value;
        } else if (pos.x < this.size.value * 2) {
          pos.x += this.size.value;
        }
      }

      if (Utils_1.isInArray(outMode, Enums_1.OutMode.bounce) || Utils_1.isInArray(outMode, Enums_1.OutMode.bounceVertical)) {
        if (pos.y > container.canvas.size.height - this.size.value * 2) {
          pos.y -= this.size.value;
        } else if (pos.y < this.size.value * 2) {
          pos.y += this.size.value;
        }
      }

      if (this.checkOverlap(pos, tryCount)) {
        return this.calcPosition(container, undefined, zIndex, tryCount + 1);
      }

      return pos;
    }
  }, {
    key: "checkOverlap",
    value: function checkOverlap(pos) {
      var tryCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var overlapOptions = this.options.collisions.overlap;

      if (!overlapOptions.enable) {
        var retries = overlapOptions.retries;

        if (retries >= 0 && tryCount > retries) {
          throw new Error("Particle is overlapping and can't be placed");
        }

        var overlaps = false;

        var _iterator5 = _createForOfIteratorHelper(this.container.particles.array),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var particle = _step5.value;

            if (Utils_1.getDistance(pos, particle.position) < this.size.value + particle.size.value) {
              overlaps = true;
              break;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        return overlaps;
      }

      return false;
    }
  }, {
    key: "calculateVelocity",
    value: function calculateVelocity() {
      var baseVelocity = Utils_1.getParticleBaseVelocity(this.direction);
      var res = baseVelocity.copy();
      var moveOptions = this.options.move;
      var rad = Math.PI / 180 * moveOptions.angle.value;
      var radOffset = Math.PI / 180 * moveOptions.angle.offset;
      var range = {
        left: radOffset - rad / 2,
        right: radOffset + rad / 2
      };

      if (!moveOptions.straight) {
        res.angle += Utils_1.randomInRange(Utils_1.setRangeValue(range.left, range.right));
      }

      if (moveOptions.random && typeof moveOptions.speed === "number") {
        res.length *= Math.random();
      }

      return res;
    }
  }, {
    key: "loadShapeData",
    value: function loadShapeData(shapeOptions, reduceDuplicates) {
      var shapeData = shapeOptions.options[this.shape];

      if (shapeData) {
        return Utils_1.deepExtend({}, shapeData instanceof Array ? Utils_1.itemFromArray(shapeData, this.id, reduceDuplicates) : shapeData);
      }
    }
  }, {
    key: "loadLife",
    value: function loadLife() {
      var container = this.container;
      var particlesOptions = this.options;
      var lifeOptions = particlesOptions.life;
      var life = {
        delay: container.retina.reduceFactor ? Utils_1.getRangeValue(lifeOptions.delay.value) * (lifeOptions.delay.sync ? 1 : Math.random()) / container.retina.reduceFactor * 1000 : 0,
        delayTime: 0,
        duration: container.retina.reduceFactor ? Utils_1.getRangeValue(lifeOptions.duration.value) * (lifeOptions.duration.sync ? 1 : Math.random()) / container.retina.reduceFactor * 1000 : 0,
        time: 0,
        count: particlesOptions.life.count
      };

      if (life.duration <= 0) {
        life.duration = -1;
      }

      if (life.count <= 0) {
        life.count = -1;
      }

      return life;
    }
  }]);

  return Particle;
}();

exports.Particle = Particle;